"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _GridContainer = _interopRequireDefault(require("../../components/Grid/GridContainer/GridContainer"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["headingCopy"];
var _templateObject, _templateObject2, _templateObject3;
var StyledLayoutContainer = (0, _styledComponents.default)(_GridContainer.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  padding-bottom: 75px; \n  padding-top: 75px;\n  padding-left: 10px !important; \n  padding-right: 10px !important;\n  overflow: hidden;\n"])));
var StyledSectionHeading = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
    children = _ref.children;
  return _react.default.createElement(_Heading.default, {
    h1: true,
    pink: true,
    className: className
  }, " ", children, " ");
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  text-align: center;\n"])));
var StyledSectionSubheading = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className,
    children = _ref2.children;
  return _react.default.createElement(_Heading.default, {
    h3: true,
    white: true,
    special: true,
    className: className
  }, " ", children, " ");
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var ResourceList = function ResourceList(_ref3) {
  var headingCopy = _ref3.headingCopy,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(StyledLayoutContainer, Object.assign({
    justifyContent: "flex-start"
  }, props), _react.default.createElement(StyledSectionHeading, Object.assign({
    xs: 12
  }, props), headingCopy)));
};
var _default = ResourceList;
exports.default = _default;